export default __webpack_public_path__ + "static/media/vaaka1.3090d756.JPG";